import { render } from "./AlarmTrigger.vue?vue&type=template&id=b9a10b00&scoped=true"
import script from "./AlarmTrigger.vue?vue&type=script&lang=js"
export * from "./AlarmTrigger.vue?vue&type=script&lang=js"

import "./AlarmTrigger.vue?vue&type=style&index=0&id=b9a10b00&scoped=true&lang=css"
import "./AlarmTrigger.vue?vue&type=style&index=1&id=b9a10b00&lang=css"
import "./AlarmTrigger.vue?vue&type=style&index=2&id=b9a10b00&lang=scss"

import exportComponent from "/home/smileythane/Projects/ixarma-ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b9a10b00"]])

export default __exports__